import { api } from "./api"
import { dedupedFetch } from "./cache"

export interface CategoriaECBB {
    _id: string;
    created: number;
    title: string;
    updated: number;
}

export interface PerspectivaECBB {
    label: string;
    _id: string;
    created: number;
    category: {
        _id: string;
        value: string;
        label: string;
    };
    title: string;
    strategicDrivers: {
        [key: string]: string;
    };
    updated: number;
}

const getRealizationCategories = async() =>
{
    try{
        const {data} = await api.post('/find/realization_categories', {});

        if(!Array.isArray(data)){
            return [];
        }
        const list = data.reduce((category, item) => {
            let categoryItem = category.find((c:any) => c.categoria === item.categoria);

            if (!categoryItem) {
                categoryItem = { categoria: item.categoria, data: [] };
                category.push(categoryItem);
            }

            categoryItem.data.push({
                _id: item._id,
                cod_indicador: item.cod_indicador,
                indicador: item.indicador,
                categoria: item.categoria
            });

            return category;
        }, []);

        list.unshift({
            categoria:'Todas',
            data:[]
        })
       
        return list;
        
    }catch(e){
        throw e
    }
}

const getCategoriasECBB = async (): Promise<CategoriaECBB[]> => {
    try {
        const { data } = await api.get<CategoriaECBB[]>('database/categoria__c');
        
        if (!Array.isArray(data)) {
            return [];
        }
        
        return data;
    } catch (e) {
        console.error('Erro ao buscar categorias ECBB:', e);
        return [];
    }
}

const getPerspectivasECBB = async (): Promise<PerspectivaECBB[]> => {
    return dedupedFetch("perspectivas-elbb", async () => {
        const { data } = await api.get<PerspectivaECBB[]>('database/perspectiva__c?q=category.value:"ELBB"');

        if (!Array.isArray(data)) {
            return [];
        }

        return data;
    }, 120_000);
}

const getBlocosConexao = async (): Promise<PerspectivaECBB[]> => {
    return dedupedFetch("blocos-conexao", async () => {
        const { data } = await api.get<PerspectivaECBB[]>(
          'database/perspectiva__c?q=category.label:"Conexão"'
        );

        if (!Array.isArray(data)) {
            return [];
        }

        return data;
    }, 120_000);
}

export {
    getRealizationCategories,
    getCategoriasECBB,
    getPerspectivasECBB,
    getBlocosConexao
}